import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ScreeningLight, ObjectUpdatePayload, Screening, GroupPMScoreRecord } from 'src/app/models/screeningInvite';
import { ScreeningService } from 'src/app/screening-module/services/screening.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { HardDeclineReason, ReviewRequiredReason } from 'src/app/models/hardDeclineReason';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RiqAlertComponent } from '../riq-alert/riq-alert.component';
import { Observable, Subscription } from 'rxjs';
import { tap, take } from 'rxjs/operators';
import { trigger, style, state, transition, animate } from '@angular/animations';
import { GroupedApplicantData } from 'src/app/models/ApplicantDataModels/GroupedApplicantData';
import { GroupApplicantsService } from 'src/app/services/group-applicants.service';
import { FilteredModel } from 'src/app/models/filteredModel';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FilteringService } from 'src/app/services/filtering.service';
@Component({
  selector: 'app-recommended-decision-mgr',
  templateUrl: './recommended-decision-mgr.component.html',
  styleUrls: ['./recommended-decision-mgr.component.less']
})
export class RecommendedDecisionMgrComponent implements OnInit, OnDestroy {
  _reasons : Array<ReviewRequiredReason> = [];
  _reasonToAdd: ReviewRequiredReason;
  groupScore : GroupPMScoreRecord;
  removing : boolean;
  newReasonAdd : boolean = false;
  @Input() hasUnverifiedIncome : boolean;
  newDeclineReasonHolder : HardDeclineReason;
  @Input() public screeningToEdit: ScreeningLight;
  @Input() public screeningRefreshed: EventEmitter<boolean>;
  private onScreeningRefreshed: Subscription;
  @Output() selectionChange : EventEmitter<MatSelectChange> = new EventEmitter<MatSelectChange>();
  @Input() reloadin : boolean;
  public activeId : number;
  public get newDeclineString() : string {
    return JSON.stringify(this.newDeclineReasonHolder);
  }

  public get groupedApplicants() : Screening[] {
    if(this.screeningToEdit.coApp && !this.groups.groupScreenings) return [];
    // else if(!this.screeningToEdit.coApp) return [this.screeningToEdit]
    else return this.groups.groupScreenings;
  }

  
  public get canSetRecDec() : boolean {
    return !this.reloadin;
  }
  
  constructor(public screening : ScreeningService, public auth : AuthService, public appData : ApplicantDataService, public toast : ToastrService,public readonly modalService: NgbModal,
    public groups: GroupApplicantsService, public router: Router, public filtering :FilteringService ) { }

  ngOnDestroy(): void {
    if(this.onScreeningRefreshed) this.onScreeningRefreshed.unsubscribe();
  }

  ngOnInit() { 
    this.activeId = this.screeningToEdit.id;

    if(!this.screeningToEdit.coApp)
    {
      this.screening.GetScreeningById(this.screeningToEdit.screeningId,true).pipe(tap((_:Screening)=>{
        this.groups.groupScreenings = [];
        let scrn = new Screening(_)
        scrn.hasUnverifiedIncome = this.hasUnverifiedIncome;
        this.groups.groupScreenings.push(scrn)
      })).subscribe();

    }

    this.onScreeningRefreshed = this.screeningRefreshed.pipe(
      tap(_ => {
        // this.setPropArray();
          if(this.screeningToEdit.coApp){
            this.screening.GetGroupScoreForToken(this.screeningToEdit.groupId).pipe(tap((_ : GroupPMScoreRecord)=>{
            this.groupScore = _;
          })).subscribe();
        }else {
        this.screening.GetScreeningById(this.screeningToEdit.screeningId,true).pipe(tap((_:Screening)=>{
          this.groups.groupScreenings = [];
          let scrn = new Screening(_)
          scrn.hasUnverifiedIncome = this.hasUnverifiedIncome;
          this.groups.groupScreenings.push(scrn)
        })).subscribe(); 
      }
      })
    ).subscribe();

    //RIQ-3038: get the group score if there is one.
    if(this.screeningToEdit.coApp){
      this.screening.GetGroupScoreForToken(this.screeningToEdit.groupId).pipe(tap((_ : GroupPMScoreRecord)=>{
        this.groupScore = _
      })).subscribe();
    }

    // RIQ-3278: Review Required Reasons
    this.screening.FetchReviewRequiredReasons().pipe(tap((_: Array<ReviewRequiredReason>)=>{
      this._reasons = _;
    })).subscribe()
  }

  saveReviewReason(rrr : ReviewRequiredReason, s : Screening){
    // console.log('adding rr reason', this._reasonToAdd);
    if(s.rrReasons.filter(srrr=>{return srrr.id == this._reasonToAdd.id}).length == 0){
      this.screening.AddReviewRequiredReasonsScrn(s.id,s.invitation.id,this._reasonToAdd.id).pipe(tap((_ : boolean)=>{
        if(_){
          this.screening.FetchReviewRequiredReasonsScrn(s.id).pipe(tap((_:ReviewRequiredReason[])=>{
            s.rrReasons = _;
          })).subscribe();
          // s.rrReasons.push(rrr);
          this.toast.success('Review Reason Added!');
        }
      })).subscribe();
    }else{
      this.toast.warning(`There is already a review reason on this report for ${this._reasonToAdd.reasonText}`, 'Duplicate Reason Detected');
    }

  }

  initRemoveRR(rrr : ReviewRequiredReason, scr : Screening){
      this.screening.RemoveReviewRequiredReasonsScrn(scr.id, rrr.id).pipe(tap((_:any)=>{
        this.toast.success('Review Reason Removed!');
        this.screening.FetchReviewRequiredReasonsScrn(scr.id).pipe(tap((_:ReviewRequiredReason[])=>{
          scr.rrReasons = _;
        })).subscribe();
      })).subscribe();
  }

  public navToReport(g: Screening) {
    // console.log(g);
    window.open(environment.portal + '/screenings/review/' + g.id);
  }

  public get hardDeclineTriggered() : boolean {
    if(!this.screeningToEdit) return false;
    return this.screeningToEdit.recommendedDecision == "Decline";
  }
  
  //ONLY the hard declines that are not already assigned to this screening... NO DUPES
  public get hardDeclines() : HardDeclineReason[] {
    if(this.screeningToEdit.hardDeclineReasons){ // then we need to show the list as selected
      var appliedIds = this.screeningToEdit.hardDeclineReasons.map(r => {return r.id});

      // Filter to the ones that are NOT in the appliedIds list
      return this.auth.hardDeclineReasons.filter(r =>{ 
        return !appliedIds.find(rs =>{return rs == r.id})
      });

    }
    return this.auth.hardDeclineReasons;
  }

  public saveRecommendedDecsion(s: Screening) {
      this.screening.UpdateScreeningPIT(s).subscribe((rsp : any)=>{
        this.toast.success('Recommended decision set successfully.');
        if((s.recommendedDecision != "Review Required" && s.recommendedDecision != "Decline") && s.rrReasons && s.rrReasons.length > 0)
        {
          s.rrReasons.forEach(element => {
            this.screening.RemoveReviewRequiredReasonsScrn(s.id,element.id).subscribe();
          });
        }
      })

    // If we are moving away from decline then we need to clear out any hard decline reasons.
    if(s.recommendedDecision != "Decline" && s.hardDeclineReasons && s.hardDeclineReasons.length > 0)
    {
      s.hardDeclineReasons.forEach(element => {
        if(!element.overrideCalcs) this.removeDecision(element,s);
      });
    }
  }

  public processChange(e: any)
  {
    this.newDeclineReasonHolder.id = e.id;
    this.newDeclineReasonHolder.displayMessage = e.displayMessage;
    // this.toast.warning(JSON.stringify(this.newDeclineReasonHolder));
  }

  public saveReason(g : Screening){
    if(!this.newDeclineReasonHolder.declineNote) this.newDeclineReasonHolder.declineNote = this.newDeclineReasonHolder.displayMessage;
    // Validate that the reason and note are set on it.
    if(!g.hardDeclineReasons) g.hardDeclineReasons = [];
    g.hardDeclineReasons.push(this.newDeclineReasonHolder);
    this.appData.AddHardDeclineReasonToScreening(this.newDeclineReasonHolder).subscribe(
      (scc : boolean) =>{ 
        this.toast.success("Hard Decline Reason Added Successfully");
        this.newReasonAdd = false;
        this.newDeclineReasonHolder = undefined;
      },
      (err: any) => { this.toast.error(`Error Adding Hard Decline Reason To Report : ${err.error}`)}
    )
    this.screening.SaveScreeningPITLog(g);
  }

  public addHardDeclineReason(g: Screening)
  {
    if(!this.newReasonAdd){
      // this.toast.warning('TRYING TO RESET HARD DECLINE REASON');
      this.newReasonAdd = true;
      this.newDeclineReasonHolder  = new HardDeclineReason();
      this.newDeclineReasonHolder.dateSet = moment(new Date());
      this.newDeclineReasonHolder.userName = this.auth.loggedInUser.userName;
      this.newDeclineReasonHolder.userId = this.auth.loggedInUser.id;
      this.newDeclineReasonHolder.screeningId = g.id;
    }
  }

  public initRemove(r : HardDeclineReason, s: Screening){
    const modalRef = this.modalService.open(RiqAlertComponent, { centered: true, size: 'sm' });
    modalRef.componentInstance.title = r.overrideCalcs ? "This decision has been overridden by the property. To change this decision, please be sure you have gotten approval from upper management before proceeding. Do you have the approval to make this change?" :  "Are you sure you want to do this?";
    modalRef.componentInstance.confirmButtonText = "Yes";
    modalRef.componentInstance.cancelButtonText = "Cancel";
    modalRef.componentInstance.alertBody = "";
      modalRef.componentInstance.evnt.subscribe((ev:boolean)=>{
        this.removeDecision(r, s);
        modalRef.dismiss()
      });
  }
  
  public removeDecision(r : HardDeclineReason, s : Screening)
  {
      this.appData.RemoveHardDeclineReasonForScreening(r).subscribe(
        (scc : boolean) =>{ 
          this.toast.success("Hard Decline Reason Removed Successfully");
          // console.warn('removal',s)
          s.hardDeclineReasons = s.hardDeclineReasons.filter(rsn => {return rsn.id != r.id});
          this.screening.SaveScreeningPITLog(s);
          // this.setPropArray();
        },
        (err: string) => { this.toast.error(`Error Removing Hard Decline Reason from report : ${err}`)}
      )
  }
}
